import { Component, model } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { CmsRouterLinkDirective } from '@boels/shared-state';
import { FormErrorsComponent } from '../../../form/form-errors/form-errors.component';
import { TextareaComponent } from '../../../form/textarea/textarea.component';
import { CheckoutInputLimitEnum } from '@boels/models';
import { ReviewRentalConditionForm } from '../checkout-review-and-confirmation.base';

@Component({
  selector: 'boels-review-rental-condition',
  templateUrl: './review-rental-condition.component.html',
  styleUrls: ['./review-rental-condition.component.scss'],
  imports: [
    TranslocoModule,
    ReactiveFormsModule,
    CmsRouterLinkDirective,
    FormErrorsComponent,
    TextareaComponent,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['checkout'],
    },
  ],
})
export class ReviewRentalConditionComponent {
  reviewRentalConditionForm =
    model.required<FormGroup<ReviewRentalConditionForm>>();
  protected readonly remarkInputLimit = CheckoutInputLimitEnum.REMARKS_S4;
}
